/* AMORmeble — progressive enhancement only. Everything works without it. */
(() => {
  const reduce = matchMedia('(prefers-reduced-motion: reduce)').matches;
  /* Runs fn once, on the visitor's first scroll, tap, key press or mouse move (4.10.2026). Rotating bars and
     autoplaying banners wait for it: anything that keeps changing while the page loads counts as unfinished
     rendering (Lighthouse Speed Index), costs paint work on slow phones, and nobody watches it before they
     interact anyway. */
  const afterFirstInput = (fn) => {
    const evs = ['scroll', 'pointerdown', 'keydown', 'touchstart', 'wheel', 'mousemove'];
    let done = false;
    const go = () => { if (done) return; done = true; evs.forEach((t) => removeEventListener(t, go, true)); fn(); };
    evs.forEach((t) => addEventListener(t, go, { passive: true, capture: true }));
  };

  /* Announcement rotation (mobile only — desktop shows all items). 13.10.2026 (audit A11Y-03, WCAG 2.2.2): it holds
     while the pointer or the keyboard focus is on the bar, and the pause button (sections/am-announcement, shown
     only where the bar rotates) stops it until it is pressed again. */
  document.querySelectorAll('[data-am-rotate]').forEach((root) => {
    const items = [...root.querySelectorAll('.am-announce__item')];
    if (items.length < 2 || reduce) return;
    const box = root.closest('.am-announce') || root;
    const btn = box.querySelector('[data-am-rotate-pause]');
    let i = 0, timer, live = false, held = false, stopped = false;
    const mq = matchMedia('(max-width: 989px)');
    const step = () => { items[i].classList.remove('is-on'); i = (i + 1) % items.length; items[i].classList.add('is-on'); };
    const run = () => {
      clearInterval(timer);
      if (btn) btn.hidden = !mq.matches;
      if (live && mq.matches && !document.hidden && !held && !stopped) timer = setInterval(step, 4000);
    };
    box.addEventListener('pointerenter', () => { held = true; run(); });
    box.addEventListener('pointerleave', () => { held = false; run(); });
    box.addEventListener('focusin', () => { held = true; run(); });
    box.addEventListener('focusout', (e) => { if (!box.contains(e.relatedTarget)) { held = false; run(); } });
    if (btn) btn.addEventListener('click', () => { stopped = !stopped; btn.setAttribute('aria-pressed', String(stopped)); run(); });
    document.addEventListener('visibilitychange', run);
    mq.addEventListener('change', run);
    run();
    afterFirstInput(() => { live = true; run(); });
  });

  /* Sliders: arrows scroll by one viewport of cards; state updated on scrollend-ish */
  const sync = (track) => {
    const box = track.closest('[data-am-slider]'); if (!box) return;
    const [prev, next] = box.querySelectorAll('.am-arrow');
    if (!prev) return;
    prev.disabled = track.scrollLeft < 4;
    next.disabled = track.scrollLeft + track.clientWidth >= track.scrollWidth - 4;
  };
  document.querySelectorAll('[data-am-slider] .am-slider').forEach((track) => {
    let raf = 0;
    track.addEventListener('scroll', () => { if (!raf) raf = requestAnimationFrame(() => { raf = 0; sync(track); }); }, { passive: true });
    sync(track);
  });

  /* Wide tables in policy and page text scroll sideways inside their own box on phones (amor-base.css).
     A box that actually scrolls gets keyboard focus, so it can be scrolled with the arrow keys too. */
  const wideTables = document.querySelectorAll('.shopify-policy__body .rte table, .page-width--narrow > .rte table');
  if (wideTables.length) {
    const markScroll = () => wideTables.forEach((t) => {
      if (t.scrollWidth > t.clientWidth + 1) t.tabIndex = 0; else t.removeAttribute('tabindex');
    });
    markScroll();
    addEventListener('resize', markScroll, { passive: true });
  }

  document.addEventListener('click', (e) => {
    /* mobile menu: X button or a tap on the dimmed page closes it; close open nav dropdowns on outside click */
    if (e.target.closest('.am-drawer__scrim, [data-am-close]')) { const b = e.target.closest('.am-burger'); if (b) b.removeAttribute('open'); }
    /* Newsletter boxes: a tap on the offer ("25 zł rabatu na zakupy od 800 zł") or the box around the form moves to the
       e-mail field. Clarity (12.10.2026): in three sessions customers tapped that text and nothing happened. */
    const news = e.target.closest('.am-gb--news');
    if (news && !e.target.closest('a, button, input, select, textarea, label')) {
      const mail = news.querySelector('input[type="email"]');
      if (mail && document.activeElement !== mail) mail.focus();
    }
    document.querySelectorAll('.am-nav__dd[open]').forEach((d) => { if (!d.contains(e.target)) d.removeAttribute('open'); });
    const arrow = e.target.closest('.am-arrow');
    if (arrow) {
      const track = arrow.closest('[data-am-slider]').querySelector('.am-slider');
      const dir = arrow.dataset.dir === 'prev' ? -1 : 1;
      if (track.amGo) track.amGo(dir);
      else track.scrollBy({ left: dir * track.clientWidth * 0.9, behavior: reduce ? 'auto' : 'smooth' });
      return;
    }
    /* Card colour swatches: swap the card to the sibling product in place. A product sold in one
       colour shows a single, inert swatch (a span with no data): a tap on it used to run this
       swap with empty data and wrote "undefined" into the title, price and cart form. */
    const sw = e.target.closest('.am-card__sw');
    if (sw) {
      if (!sw.dataset.url) return;
      const card = sw.closest('.am-card'), d = sw.dataset;
      const cur = card.querySelector('.am-card__sw[aria-pressed=true]');
      if (cur === sw) return;
      const oldUrl = cur && cur.dataset.url;
      card.querySelectorAll('.am-card__sw').forEach((b) => b.setAttribute('aria-pressed', b === sw));
      card.querySelectorAll('a[href]').forEach((a) => { if (oldUrl && a.getAttribute('href') === oldUrl) a.setAttribute('href', d.url); });
      const t = card.querySelector('.am-card__title a'); if (t) t.textContent = d.title;
      const pr = card.querySelector('.am-card__price'); if (pr) pr.innerHTML = d.price;
      const imgs = [...card.querySelectorAll('.am-card__img:not(.am-card__img--tech)')];
      const tech = card.querySelector('.am-card__img--tech');
      if (tech && d.tech && !tech.classList.contains('is-on')) { tech.dataset.src = d.tech; tech.dataset.srcset = ''; tech.removeAttribute('src'); tech.removeAttribute('srcset'); }
      if (imgs[0] && d.img) { imgs[0].srcset = d.srcset || ''; imgs[0].src = d.img; imgs[0].alt = d.title; }
      if (imgs[1]) { if (d.img2) { imgs[1].dataset.src = d.img2; imgs[1].dataset.srcset = d.srcset2 || ''; imgs[1].removeAttribute('src'); imgs[1].removeAttribute('srcset'); } }
      const slides = [...card.querySelectorAll('.am-card__img, .am-card__dim')];
      slides.forEach((s, k) => s.classList.toggle('is-on', k === 0));
      card.querySelectorAll('.am-card__pips i').forEach((p, k) => p.classList.toggle('is-on', k === 0));
      const chip = card.querySelector('.am-chip'); if (chip) { const i = chip.querySelector('i'); if (i) i.style.background = d.sw; const c = chip.querySelector('.am-chip__c'); if (c) c.textContent = ' · ' + d.kol; const b = chip.querySelector('b'); if (b && d.kname) b.textContent = d.kname; if (d.kurl) chip.setAttribute('href', d.kurl); }
      const id = card.querySelector('form input[name=id]'); if (id) id.value = d.vid;
      const btn = card.querySelector('form [type=submit]'); if (btn) btn.disabled = !d.add;
      return;
    }
    /* Card gallery: photos + producer technical drawing */
    const nav = e.target.closest('.am-card__nav');
    if (nav) {
      e.preventDefault();
      const media = nav.closest('.am-card__media');
      const slides = [...media.querySelectorAll('.am-card__img, .am-card__dim')];
      const pips = [...media.querySelectorAll('.am-card__pips i')];
      let c = slides.findIndex((s) => s.classList.contains('is-on'));
      c = (c + (nav.classList.contains('am-card__nav--prev') ? -1 : 1) + slides.length) % slides.length;
      slides.forEach((s, k) => s.classList.toggle('is-on', k === c));
      pips.forEach((p, k) => p.classList.toggle('is-on', k === c));
      const img = slides[c];
      if (img.dataset.src) { img.src = img.dataset.src; img.srcset = img.dataset.srcset || ''; delete img.dataset.src; }
    }
  });

  /* Mobile menu. Opening locks the page behind it; closing folds every section back up, so the next
     open always starts from the short list. Sections work as an accordion: opening one closes the others.
     "toggle" does not bubble, hence the capture listener. */
  document.addEventListener('toggle', (e) => {
    const el = e.target;
    if (el.classList && el.classList.contains('am-burger')) {
      document.documentElement.classList.toggle('am-lock', el.open);
      if (!el.open) el.querySelectorAll('.am-drawer__sub[open]').forEach((d) => d.removeAttribute('open'));
      // 13.10.2026 (audit A11Y-01): focus goes into the drawer, on its close button
      if (el.open) { const x = el.querySelector('.am-drawer__x'); if (x) x.focus({ preventScroll: true }); }
    } else if (el.classList && el.classList.contains('am-drawer__sub') && el.open) {
      el.closest('.am-drawer').querySelectorAll('.am-drawer__sub[open]').forEach((d) => { if (d !== el) d.removeAttribute('open'); });
    }
  }, true);
  /* 13.10.2026 (audit A11Y-01, WCAG 2.4.3): while the mobile menu is open, Tab and Shift+Tab stay inside it,
     going round from the last item to the first and back; Esc (below) closes it and returns to the burger. */
  document.addEventListener('keydown', (e) => {
    if (e.key !== 'Tab') return;
    const b = document.querySelector('.am-burger[open]');
    const panel = b && b.querySelector('.am-drawer__panel');
    if (!panel) return;
    const f = [...panel.querySelectorAll('a[href], button:not([disabled]), input:not([disabled]):not([type="hidden"]), select, textarea, summary, [tabindex]:not([tabindex="-1"])')]
      .filter((x) => x.getClientRects().length > 0);
    if (!f.length) return;
    const first = f[0], last = f[f.length - 1], a = document.activeElement;
    if (!panel.contains(a)) { e.preventDefault(); (e.shiftKey ? last : first).focus(); }
    else if (e.shiftKey && a === first) { e.preventDefault(); last.focus(); }
    else if (!e.shiftKey && a === last) { e.preventDefault(); first.focus(); }
  });
  document.addEventListener('keydown', (e) => {
    if (e.key !== 'Escape') return;
    const dd = document.querySelector('.am-nav__dd[open]');
    if (dd) { dd.removeAttribute('open'); const s = dd.querySelector('summary'); if (s) s.focus(); return; }
    const b = document.querySelector('.am-burger[open]');
    if (b) { b.removeAttribute('open'); const s = b.querySelector('summary'); if (s) s.focus(); }
  });
  /* Back/forward cache can restore the page with the menu still open. */
  addEventListener('pageshow', () => document.querySelectorAll('.am-burger[open], .am-nav__dd[open]').forEach((b) => b.removeAttribute('open')));

  /* Desktop menu pills: a mouse opens a sub-menu on hover (a short delay so a pointer passing over the bar
     does not open it, a longer one before closing so it can reach the menu). Click, Enter and Esc work as
     before; touch and pen keep tap-to-open, because only mouse pointers are handled here. */
  const desk = matchMedia('(min-width: 990px)');
  document.querySelectorAll('.am-nav__dd').forEach((d) => {
    let tOpen = 0, tShut = 0, byHover = false;
    d.addEventListener('pointerenter', (e) => {
      if (e.pointerType !== 'mouse' || !desk.matches) return;
      clearTimeout(tShut);
      if (d.open) return;
      const switching = !!document.querySelector('.am-nav__dd[open]');
      tOpen = setTimeout(() => {
        document.querySelectorAll('.am-nav__dd[open]').forEach((o) => { if (o !== d) o.removeAttribute('open'); });
        d.open = true; byHover = true;
      }, switching ? 0 : 90);
    });
    d.addEventListener('pointerleave', (e) => {
      if (e.pointerType !== 'mouse') return;
      clearTimeout(tOpen);
      tShut = setTimeout(() => { if (!d.querySelector(':focus-visible')) d.open = false; byHover = false; }, 200);
    });
    /* A click on a pill the pointer has just opened would fold it again: keep it open instead. */
    const sum = d.querySelector('summary');
    if (sum) sum.addEventListener('click', (e) => { if (byHover && d.open) { e.preventDefault(); byHover = false; } });
    /* Keyboard: Tab past the last link closes the sub-menu. */
    d.addEventListener('focusout', (e) => { if (e.relatedTarget && !d.contains(e.relatedTarget)) d.open = false; });
  });
  /* Collection photos in the grid menu are lazy; start loading them as soon as the pointer or focus reaches the bar. */
  const deskNav = document.querySelector('.am-nav');
  if (deskNav) {
    const warm = () => deskNav.querySelectorAll('.am-mm img[loading="lazy"]').forEach((i) => { i.loading = 'eager'; });
    deskNav.addEventListener('pointerenter', warm, { once: true });
    deskNav.addEventListener('focusin', warm, { once: true });
  }

  /* Collection filters: submit on change (form also has a submit button without JS) */
  document.querySelectorAll('form[data-am-filters]').forEach((form) => {
    form.addEventListener('change', () => form.requestSubmit ? form.requestSubmit() : form.submit());
  });

  /* Drag-to-scroll for horizontal option rows (touch scrolls natively) */
  document.querySelectorAll('[data-am-drag]').forEach((el) => {
    let x0 = 0, s0 = 0, down = false, moved = false;
    el.addEventListener('pointerdown', (e) => { if (e.pointerType !== 'mouse') return; down = true; moved = false; x0 = e.clientX; s0 = el.scrollLeft; });
    el.addEventListener('pointermove', (e) => { if (!down) return; const dx = e.clientX - x0; if (Math.abs(dx) > 4) { moved = true; el.classList.add('is-drag'); } el.scrollLeft = s0 - dx; });
    const up = () => { down = false; el.classList.remove('is-drag'); };
    el.addEventListener('pointerup', up); el.addEventListener('pointerleave', up);
    el.addEventListener('click', (e) => { if (moved) { e.preventDefault(); e.stopPropagation(); moved = false; } }, true);
    el.addEventListener('dragstart', (e) => e.preventDefault());
    const on = el.querySelector('.is-on'); if (on && el.scrollWidth > el.clientWidth) { const a = on.getBoundingClientRect(), b = el.getBoundingClientRect(); if (a.right > b.right - 24) el.scrollLeft += a.left - b.left - (b.width - a.width) / 2; }
  });

  /* Slider controls under every horizontal slider (glass arrows + progress), shown only when there is more to scroll.
     Kept off the cards so they never cover the per-card photo arrows. */
  const RAIL = '[data-am-slider] .am-slider, .am-set__grid, .am-bundle__list--row, .am-pills, [data-am-drag]';
  const ico = (d) => '<svg viewBox="0 0 24 24" aria-hidden="true"><path d="' + (d < 0 ? 'M15 5l-7 7 7 7' : 'M9 5l7 7-7 7') + '"/></svg>';
  document.querySelectorAll(RAIL).forEach((track) => {
    const ctl = document.createElement('div');
    ctl.className = 'am-rail';
    ctl.innerHTML = '<button type="button" class="am-rail__btn" data-d="-1" aria-label="' + ((window.AMOR_I18N || {}).rail_left || 'Przewiń w lewo') + '">' + ico(-1) + '</button><span class="am-rail__bar" aria-hidden="true"><i></i></span><button type="button" class="am-rail__btn" data-d="1" aria-label="' + ((window.AMOR_I18N || {}).rail_right || 'Przewiń w prawo') + '">' + ico(1) + '</button>';
    track.after(ctl);
    const [prev, next] = ctl.querySelectorAll('button');
    const thumb = ctl.querySelector('i');

    /* Scroll by whole cards. The rail used to jump by 0.85 of the viewport, which never lands on a
       card edge - with scroll-snap: x mandatory the browser then yanked the strip to the nearest
       card, which is the flicker and the half-cut product. Scrolling to a child's own offset can't
       drift: every stop is exactly where a card starts. */
    /* Only the cards that are actually laid out. A display:none child (the lead tile is hidden on
       phones) reports offsetLeft 0, which made the step come out as 16px instead of a whole card -
       every arrow press and every autoplay step then moved by almost nothing. */
    let items = [];
    const origin = () => (items[0] ? items[0].offsetLeft : 0);
    const stepPx = () => (items.length > 1 ? items[1].offsetLeft - items[0].offsetLeft : track.clientWidth || 1);
    const perView = () => Math.max(1, Math.round(track.clientWidth / stepPx()));
    const currentIndex = () => {
      const o = origin(), x = track.scrollLeft;
      let i = 0;
      for (let n = 0; n < items.length; n++) if (items[n].offsetLeft - o <= x + 2) i = n;
      return i;
    };
    /* Arrow scrolling uses the browser's own smooth scroll. It runs on the compositor, so it stays
       fluid while images decode or other scripts run; the old per-frame scrollLeft loop ran on the
       main thread with a slow ease-in and felt laggy. Every target is a card's snap position, so
       scroll-snap has nothing to correct. If a browser ignores smooth scrolling (the strip has not
       moved after a moment), the scripted fallback below takes over: snap off for the flight,
       ease-out so it responds at once. */
    let anim = 0;
    const NATIVE = 'scrollBehavior' in document.documentElement.style;
    const scripted = (to) => {
      cancelAnimationFrame(anim);
      const from = track.scrollLeft, d = to - from;
      if (Math.abs(d) < 1) return;
      const t0 = performance.now();
      const dur = Math.min(560, Math.max(260, Math.abs(d) * 0.4));
      track.style.scrollSnapType = 'none';
      const frame = (now) => {
        const p = Math.min(1, (now - t0) / dur);
        track.scrollLeft = from + d * (1 - Math.pow(1 - p, 3));
        if (p < 1) anim = requestAnimationFrame(frame);
        else { anim = 0; track.style.scrollSnapType = ''; }
      };
      anim = requestAnimationFrame(frame);
    };
    const animate = (to) => {
      const from = track.scrollLeft;
      if (Math.abs(to - from) < 1) return;
      if (reduce) { track.scrollLeft = to; return; }
      if (!NATIVE) { scripted(to); return; }
      track.scrollTo({ left: to, behavior: 'smooth' });
      setTimeout(() => { if (Math.abs(track.scrollLeft - from) < 1) scripted(to); }, 120);
    };
    const halt = () => { if (anim) { cancelAnimationFrame(anim); anim = 0; track.style.scrollSnapType = ''; } };
    ['pointerdown', 'wheel', 'touchstart'].forEach((ev) => track.addEventListener(ev, halt, { passive: true }));

    /* Quick repeated clicks count from where the previous click was heading, not from the half-way
       point of the flight, so two clicks always move exactly two pages. */
    let aim = -1, aimAt = 0;
    const go = (dir, count) => {
      if (items.length < 2) return;
      const base = aim >= 0 && performance.now() - aimAt < 700 ? aim : currentIndex();
      const i = Math.min(Math.max(base + dir * (count || perView()), 0), items.length - 1);
      aim = i; aimAt = performance.now();
      animate(items[i].offsetLeft - origin());
    };
    track.amGo = go;

    ctl.addEventListener('click', (e) => { const b = e.target.closest('button'); if (b) go(+b.dataset.d); });

    /* scrollWidth/clientWidth force a reflow, so reading them on every scroll frame is what made
       the strip stutter. They only change on resize, so measure there and let scrolling do maths. */
    let raf = 0, max = 0, vis = 1;
    /* The photos of the next card start loading before it scrolls in (5.10.2026). Chrome already fetches
       lazy images a screen or so ahead inside a scroller; Safari waits until a card is in view, so on a slow
       connection an autoplay step or a swipe brought in an empty card. Only for strips near the screen, so
       the strips further down keep waiting their turn. */
    let near = false, ahead = 0, warmTo = 0;
    const warm = () => {
      if (!near || !items.length) return;
      const edge = track.scrollLeft + ahead;
      if (edge <= warmTo) return;
      warmTo = edge;
      const o = origin();
      for (const it of items) {
        if (it.offsetLeft - o > edge) break;
        it.querySelectorAll('img[loading="lazy"]').forEach((im) => { im.loading = 'eager'; });
      }
    };
    const measure = () => {
      items = [...track.children].filter((el) => el.getClientRects().length > 0);
      const sw = track.scrollWidth, cw = track.clientWidth;
      max = sw - cw;
      vis = cw / sw;
      ahead = cw + stepPx();
      warmTo = 0;
      ctl.hidden = max <= 4;
      thumb.style.width = (vis * 100) + '%';
      state();
    };
    const state = () => {
      raf = 0;
      if (max <= 4) return;
      thumb.style.transform = 'translateX(' + ((track.scrollLeft / max) * (1 / vis - 1) * 100) + '%)';
      prev.disabled = track.scrollLeft < 4;
      next.disabled = track.scrollLeft > max - 4;
      warm();
    };
    if ('IntersectionObserver' in window) new IntersectionObserver((rows) => { near = rows[rows.length - 1].isIntersecting; warm(); }, { rootMargin: '0px 0px 50% 0px' }).observe(track);
    track.addEventListener('scroll', () => { if (!raf) raf = requestAnimationFrame(state); }, { passive: true });
    if ('ResizeObserver' in window) new ResizeObserver(measure).observe(track);
    addEventListener('load', measure);
    measure();

    /* The progress bar is also a scrollbar. Drag the dark thumb and the strip follows the pointer
       1:1; press anywhere else on the bar and it glides there. Snap is off while dragging, then the
       strip settles on the nearest card, so no product is left half cut. touch-action: pan-y on the
       bar keeps vertical page scrolling for a finger that only passes over it. */
    const bar = ctl.querySelector('.am-rail__bar');
    let drag = null;
    const posAt = (e) => {
      const p = drag.span > 0 ? (e.clientX - drag.left - drag.grab) / drag.span : 0;
      return Math.min(1, Math.max(0, p)) * max;
    };
    const nearestTo = (x) => {
      const o = origin();
      let best = 0, gap = Infinity;
      for (const it of items) {
        const p = Math.min(it.offsetLeft - o, max), g = Math.abs(p - x);
        if (g < gap) { gap = g; best = p; }
      }
      return best;
    };
    const settle = (to) => {
      if (reduce || Math.abs(to - track.scrollLeft) < 1) { track.scrollLeft = to; track.style.scrollSnapType = ''; }
      else scripted(to);
    };
    bar.addEventListener('pointerdown', (e) => {
      if (max <= 4 || (e.pointerType === 'mouse' && e.button !== 0)) return;
      e.preventDefault();
      halt(); aim = -1;
      const r = bar.getBoundingClientRect(), t = thumb.getBoundingClientRect();
      const onThumb = e.clientX >= t.left - 4 && e.clientX <= t.right + 4;
      drag = { id: e.pointerId, x0: e.clientX, left: r.left, span: r.width - t.width, grab: onThumb ? e.clientX - t.left : t.width / 2, moved: false };
      try { bar.setPointerCapture(e.pointerId); } catch (err) { /* capture is a nicety */ }
      bar.classList.add('is-drag');
      if (!onThumb) settle(nearestTo(posAt(e)));
    });
    bar.addEventListener('pointermove', (e) => {
      if (!drag || e.pointerId !== drag.id) return;
      if (!drag.moved) {
        if (Math.abs(e.clientX - drag.x0) < 3) return;
        drag.moved = true;
        halt();
        track.style.scrollSnapType = 'none';
      }
      track.scrollLeft = posAt(e);
    });
    const release = (e) => {
      if (!drag || e.pointerId !== drag.id) return;
      const moved = drag.moved;
      drag = null;
      bar.classList.remove('is-drag');
      if (moved) settle(nearestTo(track.scrollLeft));
    };
    bar.addEventListener('pointerup', release);
    bar.addEventListener('pointercancel', release);
    bar.addEventListener('lostpointercapture', release);

    /* Gentle autoplay: while a product slider is on screen it moves one card every 4 s (same pace as the
       banners). Hover, focus or a finger on the strip holds it; arrows, the bar, keys or a sideways
       scroll stop it for good - once the customer takes over, the strip stays put. */
    if (reduce || !track.closest('[data-am-slider]') || !('IntersectionObserver' in window)) return;
    let timer = 0, boot = 0, dead = false, seen = false;
    const FIRST = 4000, GAP = 4000;
    const tick = () => {
      if (dead || document.hidden || max <= 4) return;
      if (track.scrollLeft > max - 4) animate(0);
      else go(1, 1);
    };
    const play = () => {
      if (dead || timer || boot || !seen || document.hidden) return;
      boot = setTimeout(() => { boot = 0; tick(); timer = setInterval(tick, GAP); }, FIRST);
    };
    const pause = () => { clearTimeout(boot); boot = 0; clearInterval(timer); timer = 0; };
    const stop = () => { dead = true; pause(); };
    /* Deliberate navigation ends it; a finger passing over the strip only holds it. */
    ctl.addEventListener('click', stop);
    ctl.addEventListener('pointerdown', stop);
    track.addEventListener('keydown', stop);
    track.addEventListener('wheel', (e) => { if (Math.abs(e.deltaX) > Math.abs(e.deltaY)) stop(); }, { passive: true });
    track.addEventListener('pointerenter', pause);
    track.addEventListener('pointerdown', pause);
    track.addEventListener('focusin', pause);
    track.addEventListener('pointerleave', play);
    track.addEventListener('pointerup', play);
    track.addEventListener('pointercancel', play);
    track.addEventListener('touchend', play, { passive: true });
    track.addEventListener('touchcancel', play, { passive: true });
    track.addEventListener('focusout', play);
    document.addEventListener('visibilitychange', () => (document.hidden ? pause() : play()));
    new IntersectionObserver((rows) => {
      rows.forEach((r) => {
        seen = r.isIntersecting;
        if (seen) play();
        else pause();
      });
    }, { threshold: 0.2 }).observe(track);
  });
  document.documentElement.classList.add('am-rails');

  /* PDP: prev/next over the main photo. It clicks the theme's own thumbnails rather than swapping
     images itself, so Craft keeps owning the active media, lazy loading and aria state. */
  const gal = document.querySelector('media-gallery');
  if (gal) {
    const list = gal.querySelector('.product__media-list');
    const stage = list && (list.closest('slider-component') || list.parentElement);
    const thumbs = [...gal.querySelectorAll('.thumbnail-list__item .thumbnail')];
    if (stage && thumbs.length > 1) {
      stage.classList.add('am-gal');
      const mk = (d, label) => {
        const b = document.createElement('button');
        b.type = 'button';
        b.className = 'am-gal__nav am-gal__nav--' + (d < 0 ? 'prev' : 'next');
        b.setAttribute('aria-label', label);
        b.innerHTML = ico(d);
        b.addEventListener('click', () => {
          let at = thumbs.findIndex((t) => t.getAttribute('aria-current') === 'true');
          if (at < 0) at = 0;
          thumbs[(at + d + thumbs.length) % thumbs.length].click();
        });
        return b;
      };
      stage.append(mk(-1, (window.AMOR_I18N || {}).gal_prev || 'Poprzednie zdjęcie'), mk(1, (window.AMOR_I18N || {}).gal_next || 'Następne zdjęcie'));
    }
  }

  /* Mobile sticky header: shadow once the page is scrolled */
  const hdr = document.querySelector('.am-section-header');
  if (hdr) { let on = false; const f = () => { const v = scrollY > 8; if (v !== on) { on = v; hdr.classList.toggle('is-stuck', v); } }; addEventListener('scroll', f, { passive: true }); f(); }

  /* PDP: sticky mobile add-to-cart bar (snippets/am-pdp-sticky, back since 13.10.2026 as a 2-week test, audit
     ATF-01/CLK-01). Since 24.10.2026 it shows from the first screen (no longer waits for the gallery), stays hidden for a sold-out variant, and hides while the page's own buy button (or the
     configurator's "Skonfiguruj i kup", assets/am-config.js) is on screen, so the price and the button are at hand
     before the buyer reaches them. Clicks are counted in Clarity as "pasek_dodaj_do_koszyka" (am-clarity). */
  const bar = document.querySelector('[data-am-sticky]');
  if (bar && 'IntersectionObserver' in window) {
    const gal = document.querySelector('.product__media-wrapper');
    const vis = new Map();
    let galPast = !gal;
    const upd = () => { const m = !document.querySelector('.amx-cta__btn') && document.querySelector('.product-form__buttons .product-form__submit'); bar.classList.toggle('is-on', !(m && m.disabled) && ![...vis.values()].some(Boolean)); };
    if (gal) {
      new IntersectionObserver(([en]) => { galPast = !en.isIntersecting && en.boundingClientRect.top < 0; upd(); }).observe(gal);
    }
    const io = new IntersectionObserver((ens) => { ens.forEach((en) => vis.set(en.target, en.isIntersecting)); upd(); });
    document.querySelectorAll('.product-form__buttons, .amx-cta__btn').forEach((el) => io.observe(el));
    // Same state as the page's own button: a sold-out or unavailable variant greys the bar's button out with the
    // same words ("Chwilowo niedostępne", "Niedostępny"), instead of posting a variant the shop cannot sell. Not on
    // configurable products, where the bar opens the configurator.
    const main = document.querySelector('.product-form__buttons .product-form__submit');
    const own = bar.querySelector('button[type="submit"]');
    if (main && own && !document.querySelector('.amx-cta__btn')) {
      const mirror = () => {
        own.disabled = main.disabled;
        const t = (main.querySelector('span') || main).textContent.trim();
        if (t && own.textContent !== t) own.textContent = t;
      };
      new MutationObserver(mirror).observe(main, { attributes: true, attributeFilter: ['disabled'], childList: true, subtree: true, characterData: true });
      mirror();
    }
  }

  /* Hero slider (sections/am-hero-slider). Crossfade between banners. Only the first photo comes with
     the page; the next one is fetched after the first interaction, the rest when they come up.
     The progress bar of the active dot is the clock: its CSS animation ending moves to the next banner,
     so holding the animation (hover, focus, off screen, hidden tab) holds the slider too. Any arrow, dot,
     swipe or arrow key stops autoplay for good. */
  document.querySelectorAll('[data-am-hs]').forEach((root) => {
    const slides = [...root.querySelectorAll('.am-hs__slide')];
    if (slides.length < 2) return;
    const track = root.querySelector('.am-hs__track');
    const dots = [...root.querySelectorAll('.am-hs__dot')];
    let cur = 0;
    const hydrate = (i) => {
      const s = slides[i];
      if (!s || s.dataset.ready) return;
      s.dataset.ready = '1';
      s.querySelectorAll('[data-srcset]').forEach((el) => { el.srcset = el.dataset.srcset; el.removeAttribute('data-srcset'); });
      s.querySelectorAll('img[data-src]').forEach((el) => { el.src = el.dataset.src; el.removeAttribute('data-src'); });
    };
    const holds = new Set();
    const hold = (why, on) => { if (on) holds.add(why); else holds.delete(why); root.classList.toggle('is-hold', holds.size > 0); };
    const stop = () => { root.classList.remove('is-play'); track.setAttribute('aria-live', 'polite'); };
    const show = (i, byUser) => {
      i = (i + slides.length) % slides.length;
      if (byUser) stop();
      if (i === cur) return;
      hydrate(i);
      hydrate((i + 1) % slides.length);
      const was = slides[cur], now = slides[i];
      was.classList.remove('is-on'); was.setAttribute('aria-hidden', 'true'); was.inert = true;
      now.classList.add('is-on'); now.removeAttribute('aria-hidden'); now.inert = false;
      dots.forEach((d, k) => { if (k === i) d.setAttribute('aria-current', 'true'); else d.removeAttribute('aria-current'); });
      cur = i;
    };
    root.addEventListener('click', (e) => {
      const a = e.target.closest('.am-hs__arrow');
      if (a) { show(cur + Number(a.dataset.d), true); return; }
      const d = e.target.closest('.am-hs__dot');
      if (d) { show(Number(d.dataset.i), true); return; }
      /* A click on a banner's photo, label, headline or text opens the banner's first button (12.10.2026; Clarity: a
         click on "Kolekcja LATTE · kaszmirowy beż" did nothing). Buttons, links and the "Na zdjęciu" chips keep
         their own job; a swipe never gets here (its click is swallowed above); selecting text does nothing. */
      if (e.defaultPrevented || e.button !== 0 || e.target.closest('a, button, input, select, textarea, label, summary')) return;
      if (window.getSelection && String(window.getSelection()).trim()) return;
      const slide = e.target.closest('.am-hs__slide');
      const go = slide && slide.querySelector('.am-hero__cta a[href]');
      if (go) go.click();
    });
    slides.forEach((s) => { if (s.querySelector('.am-hero__cta a[href]')) s.classList.add('am-hs__slide--link'); });
    if (!document.getElementById('am-hs-link-css')) {
      const st = document.createElement('style');
      st.id = 'am-hs-link-css';
      st.textContent = '.am-hs__slide--link .am-hero__img,.am-hs__slide--link .am-hero__copy{cursor:pointer}';
      document.head.appendChild(st);
    }
    root.addEventListener('keydown', (e) => {
      if (e.key === 'ArrowLeft' || e.key === 'ArrowRight') { e.preventDefault(); show(cur + (e.key === 'ArrowLeft' ? -1 : 1), true); }
    });
    /* Swipe on touch screens. The track allows vertical panning only, so a sideways swipe reaches us;
       the click a swipe would fire on a link under the finger is swallowed. */
    let x0 = null, y0 = 0, swiped = false;
    track.addEventListener('pointerdown', (e) => { if (e.pointerType === 'mouse') return; x0 = e.clientX; y0 = e.clientY; swiped = false; });
    track.addEventListener('pointerup', (e) => {
      if (x0 === null) return;
      const dx = e.clientX - x0, dy = e.clientY - y0;
      x0 = null;
      if (Math.abs(dx) > 48 && Math.abs(dx) > Math.abs(dy) * 1.3) { swiped = true; show(cur + (dx < 0 ? 1 : -1), true); }
    });
    track.addEventListener('pointercancel', () => { x0 = null; });
    track.addEventListener('click', (e) => { if (swiped) { e.preventDefault(); e.stopPropagation(); swiped = false; } }, true);
    /* The next banner's photo and the autoplay both wait for the first interaction (afterFirstInput), so the
       page load carries only the first photo and nothing on screen changes while it loads. */
    afterFirstInput(() => setTimeout(() => hydrate(1), 300));
    track.setAttribute('aria-live', 'polite');
    if (!root.hasAttribute('data-autoplay') || reduce) return;
    track.setAttribute('aria-live', 'off');
    afterFirstInput(() => { if (track.getAttribute('aria-live') === 'off') root.classList.add('is-play'); });
    /* On a slow connection the next photo can still be on its way when the bar fills. The slider then
       waits with a full bar until it arrives (8 s at most) instead of fading to an empty banner (5.10.2026). */
    root.addEventListener('animationend', (e) => {
      if (e.animationName !== 'amHsFill' || !root.classList.contains('is-play')) return;
      const nx = (cur + 1) % slides.length;
      hydrate(nx);
      const im = slides[nx].querySelector('.am-hero__img img');
      if (!im || (im.complete && im.naturalWidth > 0)) { show(nx, false); return; }
      hold('load', true);
      let t = 0;
      const go = () => {
        clearTimeout(t);
        im.removeEventListener('load', go);
        im.removeEventListener('error', go);
        hold('load', false);
        if (root.classList.contains('is-play') && cur !== nx) show(nx, false);
      };
      im.addEventListener('load', go);
      im.addEventListener('error', go);
      t = setTimeout(go, 8000);
    });
    root.addEventListener('pointerenter', (e) => { if (e.pointerType === 'mouse') hold('hover', true); });
    root.addEventListener('pointerleave', () => hold('hover', false));
    root.addEventListener('focusin', () => hold('focus', true));
    root.addEventListener('focusout', (e) => { if (!root.contains(e.relatedTarget)) hold('focus', false); });
    const tab = () => hold('tab', document.hidden);
    document.addEventListener('visibilitychange', tab);
    tab();
    if ('IntersectionObserver' in window) new IntersectionObserver(([en]) => hold('view', !en.isIntersecting), { threshold: 0.35 }).observe(root);
  });

  /* Shipping window as real dates: "2–7 dni roboczych" becomes e.g. "1–8 października". Counted from the
     next working day in Poland, the way the terms put it: weekends and public holidays are skipped (fixed
     ones, 24 December included since 2025, plus Easter Monday and Corpus Christi worked out from Easter).
     The element keeps its plain wording when JavaScript is off.
     Czech market (AMOR_MKT.hol "cz", snippets/am-i18n): Czech public holidays (1.1, Good Friday, Easter Monday,
     1.5, 8.5, 5.7, 6.7, 28.9, 28.10, 17.11, 24-26.12) in Prague time. A page in another language than Polish
     names the months with Intl.DateTimeFormat in that language (<html lang>) and joins the dates with the
     patterns AMOR_I18N.date_range_same / date_range_diff; Polish pages keep the code below as it was. */
  const shipEls = document.querySelectorAll('[data-am-ship]');
  if (shipEls.length) {
    const easter = (y) => {
      const a = y % 19, b = Math.floor(y / 100), c = y % 100, d = Math.floor(b / 4), e = b % 4;
      const f = Math.floor((b + 8) / 25), g = Math.floor((b - f + 1) / 3), h = (19 * a + b - d - g + 15) % 30;
      const i = Math.floor(c / 4), k = c % 4, l = (32 + 2 * e + 2 * i - h - k) % 7, m = Math.floor((a + 11 * h + 22 * l) / 451);
      const month = Math.floor((h + l - 7 * m + 114) / 31), day = ((h + l - 7 * m + 114) % 31) + 1;
      return Date.UTC(y, month - 1, day);
    };
    const key = (t) => { const x = new Date(t); return x.getUTCFullYear() + '-' + (x.getUTCMonth() + 1) + '-' + x.getUTCDate(); };
    const DAY = 864e5, off = new Set();
    const addYear = (y) => {
      const cz = (window.AMOR_MKT || {}).hol === 'cz';
      (cz ? [[1, 1], [5, 1], [5, 8], [7, 5], [7, 6], [9, 28], [10, 28], [11, 17], [12, 24], [12, 25], [12, 26]]
        : [[1, 1], [1, 6], [5, 1], [5, 3], [8, 15], [11, 1], [11, 11], [12, 24], [12, 25], [12, 26]]).forEach(([mo, d]) => off.add(y + '-' + mo + '-' + d));
      const e = easter(y);
      (cz ? [-2, 1] : [0, 1, 49, 60]).forEach((n) => off.add(key(e + n * DAY)));
    };
    let today;
    try {
      const p = new Intl.DateTimeFormat('en-CA', { timeZone: (window.AMOR_MKT || {}).tz || 'Europe/Warsaw', year: 'numeric', month: 'numeric', day: 'numeric' }).formatToParts(new Date());
      const v = (t) => Number(p.find((x) => x.type === t).value);
      today = Date.UTC(v('year'), v('month') - 1, v('day'));
    } catch (err) {
      const n = new Date(); today = Date.UTC(n.getFullYear(), n.getMonth(), n.getDate());
    }
    const y0 = new Date(today).getUTCFullYear();
    addYear(y0); addYear(y0 + 1);
    const working = (t) => { const w = new Date(t).getUTCDay(); return w !== 0 && w !== 6 && !off.has(key(t)); };
    const nth = (n) => { let t = today, c = 0; while (c < n) { t += DAY; if (working(t)) c += 1; } return new Date(t); };
    const LONG = ['stycznia', 'lutego', 'marca', 'kwietnia', 'maja', 'czerwca', 'lipca', 'sierpnia', 'września', 'października', 'listopada', 'grudnia'];
    const SHORT = ['sty', 'lut', 'mar', 'kwi', 'maj', 'cze', 'lip', 'sie', 'wrz', 'paź', 'lis', 'gru'];
    const I18N = window.AMOR_I18N || {};
    const LANG = String(document.documentElement.lang || 'pl').toLowerCase();
    const PL = LANG.slice(0, 2) === 'pl';
    // another language: month names from Intl (long) or AMOR_I18N.date_months_short ("11." in Czech)
    const monthName = (d, short) => {
      const m = d.getUTCMonth();
      const arr = String((short ? I18N.date_months_short : I18N.date_months_long) || '').split(',');
      if (!short) {
        try {
          const part = new Intl.DateTimeFormat(LANG, { timeZone: 'UTC', day: 'numeric', month: 'long' }).formatToParts(d).find((x) => x.type === 'month');
          if (part && part.value) return part.value;
        } catch (err) { /* the list below */ }
      }
      return arr[m] || (short ? SHORT : LONG)[m];
    };
    const fill = (s, o) => String(s).replace(/\{(\w+)\}/g, (x, k) => (o[k] != null ? o[k] : x));
    shipEls.forEach((el) => {
      const [a, b] = el.dataset.amShip.split('-').map(Number);
      if (!(a > 0) || !(b >= a)) return;
      const d1 = nth(a), d2 = nth(b), M = el.hasAttribute('data-short') ? SHORT : LONG;
      const short = el.hasAttribute('data-short');
      const txt = !PL
        ? (d1.getUTCMonth() === d2.getUTCMonth()
          ? fill(I18N.date_range_same || '{d1}–{d2} {m}', { d1: d1.getUTCDate(), d2: d2.getUTCDate(), m: monthName(d2, short) })
          : fill(I18N.date_range_diff || '{d1} {m1} – {d2} {m2}', { d1: d1.getUTCDate(), m1: monthName(d1, short), d2: d2.getUTCDate(), m2: monthName(d2, short) }))
        : d1.getUTCMonth() === d2.getUTCMonth()
        ? d1.getUTCDate() + '–' + d2.getUTCDate() + ' ' + M[d2.getUTCMonth()]
        : d1.getUTCDate() + ' ' + M[d1.getUTCMonth()] + ' – ' + d2.getUTCDate() + ' ' + M[d2.getUTCMonth()];
      el.textContent = (el.dataset.lead || '') + txt;
      el.title = fill(I18N.ship_title_js || '{a}–{b} dni roboczych od następnego dnia roboczego', { a: a, b: b });
    });
  }

  /* PDP description: the technical modules (load, TV fit, specs, delivery, FAQ) fold into rows, the way
     centrumkrzesel.pl keeps its product page short; the story rows above them (look, function) stay open.
     Each module becomes a closed <details> that keeps its id, with its heading moved into the <summary>.
     The producer row (snippets/am-pdp-gpsr) comes from the server already folded, in the same markup.
     A link to a module or to anything inside it (the description's own nav, #pd-dostawa) opens it first.
     Without JavaScript every module simply stays open. */
  const pd = document.querySelector('#opis .amor-pd');
  if (pd) {
    const CHEV = '<span class="am-acc__ic" aria-hidden="true"><svg viewBox="0 0 24 24"><path d="M6 9l6 6 6-6"/></svg></span>';
    ['pd-wnetrze', 'pd-tv', 'pd-spec', 'pd-dostawa', 'pd-pytania'].forEach((id) => {
      const el = document.getElementById(id);
      if (!el || el.parentElement !== pd) return;
      const h = el.querySelector(':scope > h3, :scope > .txt > h3');
      if (!h) return;
      const eb = el.querySelector(':scope > .eyebrow, :scope > .txt > .eyebrow');
      if (eb) eb.remove();
      const d = document.createElement('details');
      const s = document.createElement('summary');
      d.className = 'am-acc';
      s.className = 'am-acc__s';
      h.classList.add('am-acc__t');
      el.removeAttribute('id');
      el.classList.add('am-acc__b');
      el.replaceWith(d);
      d.id = id;
      s.append(h);
      s.insertAdjacentHTML('beforeend', CHEV);
      d.append(s, el);
    });
  }
  const openTo = (hash, jump) => {
    if (!hash || hash.length < 2) return;
    let t = null;
    try { t = document.getElementById(decodeURIComponent(hash.slice(1))); } catch (err) { return; }
    const d = t && t.closest('details.am-acc');
    if (!d || d.open) return;
    d.open = true;
    if (jump) t.scrollIntoView();
  };
  document.addEventListener('click', (e) => {
    const a = e.target.closest && e.target.closest('a[href^="#"]');
    if (a) openTo(a.getAttribute('href'));
  });
  window.addEventListener('hashchange', () => openTo(location.hash, true));
  openTo(location.hash, true);
})();
/* PDP: TV size check in the RTV descriptions. The same code used to sit inline in each description (Google and Meta read it as product text); since 04.10.2026 it lives here and the per-cabinet numbers come from data-tv="S,CW,CX,TOP,GAP" on .pd-tv. */
(() => { document.querySelectorAll('.pd-tv[data-tv]').forEach((sec) => { const [S, CW, CX, TOP, GAP] = sec.dataset.tv.split(',').map(Number); const tv = sec.querySelector('rect.tvr'), lab = sec.querySelector('text[id^="tvlab-"]'), res = sec.querySelector('.res'); if (!tv || !lab || !res) return; const btns = [...sec.querySelectorAll('.sizes button')]; const set = (inch) => { const w = inch * 2.54 * 0.8716, h = inch * 2.54 * 0.4903, pw = w * S, ph = h * S; tv.setAttribute('x', CX - pw / 2); tv.setAttribute('width', pw); tv.setAttribute('height', ph); tv.setAttribute('y', TOP - GAP - ph); lab.setAttribute('y', TOP - GAP - ph - 8); const I = window.AMOR_I18N || {}; const fl = (s, o) => String(s).replace(/\{(\w+)\}/g, (x, k) => (o[k] != null ? o[k] : x)); lab.textContent = fl(I.tv_label || '{inch}″ · ok. {w} cm', { inch: inch, w: Math.round(w) }); const m = (CW - w) / 2; res.dataset.fit = m >= 0 ? 'yes' : 'no'; res.querySelector('b').textContent = m >= 0 ? fl(I.tv_fits || 'Pasuje — po {m} cm zapasu z każdej strony', { m: Math.round(m) }) : fl(I.tv_over || 'Wystaje po ok. {m} cm z każdej strony', { m: Math.round(-m) }); res.querySelector('span').textContent = fl(I.tv_screen || 'Ekran {inch}″ w proporcji 16:9 ma ok. {w} cm szerokości i {h} cm wysokości.', { inch: inch, w: Math.round(w), h: Math.round(h) }) + (m < 0 ? ' ' + (I.tv_wall || 'Lepiej powiesić go na ścianie nad szafką.') : ''); btns.forEach((b) => b.setAttribute('aria-pressed', b.dataset.in == inch ? 'true' : 'false')); }; btns.forEach((b) => b.addEventListener('click', () => set(+b.dataset.in))); }); })();